export var AdvertisingCampaignStatus;
(function (AdvertisingCampaignStatus) {
    AdvertisingCampaignStatus["Active"] = "active";
    AdvertisingCampaignStatus["Paused"] = "paused";
    AdvertisingCampaignStatus["Inactive"] = "inactive";
})(AdvertisingCampaignStatus || (AdvertisingCampaignStatus = {}));
